// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__ISEen","colCheckbox":"styles_colCheckbox__1ALx1"};